import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { can_visit, notify } from '../../helpers';
import { ChevronDown, ChevronUp, CircleHelp, DatabaseZap, Dock, GlobeLock, Hospital, Loader, Shield, Store, UserCheck, UsersRound } from 'lucide-react';
import { setRoleExistPermissions } from '../../services/users';
import Spacing from '../Spacing';
import ServerHealth from '../Section/ServerHealth';
import { fetchFilterData } from '../../services/servers';


export default function AdminNav({setIsOpen = () => {}}) {
  const [toggle, setToggle] = useState("");
  const [rolePermissionButtonLoader, setRolePermissionButtonLoader] = useState(false);
  const [checkServerHealthLoader, setCheckServerHealthLoader] = useState(false);
  const [checkServerHealth, setCheckServerHealth] = useState(false);
  const [serverHealthData, setServerHealthData] = useState({});

  const handelToggle = (toggleItem) => {
    if (toggleItem === toggle) {
      setToggle(false);
    } else {
      setToggle(toggleItem);
    }
  };

  const handleSetPermission = async () => {
    setRolePermissionButtonLoader(true);

    try {
      const response = await setRoleExistPermissions();
      if(response){
        if(!response?.detail) {
          notify("success", "Role permissions updated successfully", 2);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setRolePermissionButtonLoader(false);
    }
  };

  const checkServer = async () => {
    setCheckServerHealthLoader(true);
    setCheckServerHealth(true);
    try {
      const response = await fetchFilterData();
      if (response) {
        setServerHealthData(response);
      }
    } catch (error) {
      notify("error", "Something went wrong", 2);
    } finally {
      setCheckServerHealthLoader(false);
    }
  }


  return (
    <div className="docpro_admin_nav">
      {(can_visit("settings") && can_visit("settings_basic_and_location_info")) && (
        <NavLink to="/admin/settings" onClick={() => setIsOpen(false)}>
          <span className="docpro_sidenav_item_icon">
            <Store height={20} width={20} />
          </span>
          <span>Practice Details</span>
        </NavLink>
      )}
      {(can_visit("settings") && can_visit("settings_users")) && (
        <>
          <Link
            className={`user_dropdown ${toggle === "invitation" ? "active" : ""}`}
            onClick={() => handelToggle("invitation")}
          >
            <span className="docpro_sidenav_item_icon">
              <UsersRound height={20} width={20} />
            </span>
            <span>Users</span>
            <span style={{ marginLeft: 'auto', textAlign: 'end' }}>
              {toggle === "invitation" ? 
                <ChevronUp height={18} width={18} />
              : 
                <ChevronDown height={18} width={18} />
              }
            </span>
          </Link>
          {toggle === "invitation" && (
            <ul className="docpro_sidenav_dropdown">
              {(can_visit("settings_users") && can_visit("settings_users_all_users")) && (
                <li>
                  <NavLink to="/admin/users" onClick={() => setIsOpen(false)}>All Users</NavLink>
                </li>
              )}
              {(can_visit("settings_users") && can_visit("settings_users_invitations")) && (
                <li>
                  <NavLink to="/admin/invitations" onClick={() => setIsOpen(false)}>Invitations</NavLink>
                </li>
              )}
            </ul>
          )}
        </>
      )}
      {can_visit("settings") && (can_visit("settings_message_credits") || can_visit("settings_letter_credits")) && (
        <NavLink to="/admin/credits" onClick={() => setIsOpen(false)}>
          <span className="docpro_sidenav_item_icon">
            <Dock height={20} width={20} />
          </span>
          <span>Credits</span>
        </NavLink>
      )}
      {/* {(can_visit("settings") && can_visit("settings_letter_credits")) && (
        <NavLink to="/admin/letter-credits">Letter Credits</NavLink>
      )} */}
      {(can_visit("settings") && can_visit("settings_support")) && (
        <NavLink to={`/admin/support`} onClick={() => setIsOpen(false)}>
          <span className="docpro_sidenav_item_icon">
            <CircleHelp height={20} width={20} />
          </span>
          <span>Support</span>
        </NavLink>
      )}
      {(can_visit("settings") && can_visit("settings_otp_setup")) && (
        <NavLink to="/admin/otpsetup" onClick={() => setIsOpen(false)}>
          <span className="docpro_sidenav_item_icon">
            <Shield height={20} width={20} />
          </span>
          <span>2FA Setup</span>
        </NavLink>
      )}
      {/* {(can_visit("settings") && can_visit("settings_scheduler_setup")) && (
        <NavLink to="/admin/schedulersetup" onClick={() => setIsOpen(false)}>
          <span>Scheduler Setup</span>
        </NavLink>
      )} */}
      {can_visit("settings") && (can_visit("settings_dummy_sms_setup") || can_visit("settings_dummy_call_setup")) && (
        <NavLink to="/admin/message-call-preferences" onClick={() => setIsOpen(false)}>
          <span className="docpro_sidenav_item_icon">
            <GlobeLock height={20} width={20} />
          </span>
          <span>SMS & Call Preferences</span>
        </NavLink>
      )}
      {can_visit("settings") && (can_visit("practice_npi_management")) && (
        <NavLink to="/admin/npi-management" onClick={() => setIsOpen(false)}>
          <span className="docpro_sidenav_item_icon">
            <Hospital height={20} width={20} />
          </span>
          <span>NPI Management</span>
        </NavLink>
      )}
      {/* {(can_visit("settings") && can_visit("settings_appointment_time_setup")) && (
        <NavLink to="/admin/appointment-time-slot">Appointment Time Slot</NavLink>
      )} */}

      {can_visit('administrator') && (
        <>
          <Spacing lg="10" sm="35" />
          <button 
            className="docpro_bordered_btn docpro_fw_600 docpro_primary_color w-full"
            style={{ justifyContent: 'start' }}
            onClick={() => handleSetPermission()}
            disabled = {rolePermissionButtonLoader ? true : false}
          >
            <UserCheck width={18} height={18} />
            <span>Update Permissions</span>
            {rolePermissionButtonLoader && (
              <span className="docpro_loading">
                <Loader width={18} height={18} />
              </span>
            )}
          </button>
          <Spacing lg="10" sm="10" />
          <button 
            className="docpro_bordered_btn docpro_fw_600 docpro_primary_color w-full"
            style={{ justifyContent: 'start' }}
            onClick={() => {
              checkServer()
            }}
            disabled = {checkServerHealthLoader ? true : false}
          >
            <DatabaseZap width={18} height={18} />
            <span>Server Health</span>
            {checkServerHealthLoader && (
              <span className="docpro_loading">
                <Loader width={18} height={18} />
              </span>
            )}
          </button>
          {checkServerHealth && (
            <ServerHealth
              checkServerHealth={checkServerHealth}
              setCheckServerHealth={setCheckServerHealth}
              checkServerHealthLoader={checkServerHealthLoader}
              setCheckServerHealthLoader={setCheckServerHealthLoader}
              serverHealthData={serverHealthData}
            />
          )}
        </>
      )}
    </div>
  );
}